<script>
export default {
  name: 'TwBadge',
  props: {
    variant: {
      type: String,
      required: false,
      default: 'gray'
    },
    size: {
      type: String,
      default: null,
    }
  },
  computed: {
    variantClasses() {
      return `bg-${this.variant}-100 text-${this.variant}-800 border-${this.variant}-400`;
    },
    sizeClasses() {
      switch(this.size) {
      case 'sm':
        return 'px-2 py-0 text-base/1';
      case 'lg':
        return 'px-3 py-1 text-lg';
      default:
        return 'px-2 py-1 text-xs ';
      }
    },
    classes() {
      return `${this.variantClasses} ${this.sizeClasses}`;
    }
  }
}
</script>

<template>
  <span :class="'inline-flex items-center rounded-full border-1 border-solid ' + classes"><slot /></span>
</template>

<style scoped>

</style>
